import {SET_USER_WON} from "@actions/actionTypes";

export default function userWonReducer(state = 0, action) {
    switch (action.type) {
        case SET_USER_WON:
            return action.wonAmount
        default:
            return state;
    }
}